import event from '../../../event'

function AuthCheckRouteGuard (to, from, next) {
  if (to.path !== '/login' && !to.path.startsWith('/health-check')) {
    event.$emit('loading-on')
    this.dispatch('initAuth')
      .then((d) => {
        if (!this.getters['authentication/isAuthenticated']) {
          event.$emit('loading-off')
          next('/login')
        } else {
          this.dispatch('authorization/refreshToken')
            .then((res) => {
              this.dispatch('authentication/refreshToken')
                .then((res) => {
                  event.$emit('loading-off')
                  next()
                }).catch((err) => {
                  // couldn't authorize so send error message @todo
                  event.$emit('loading-off')
                  console.log(err)
                  next('/login')
                  event.$emit('logout')
                })
            }).catch((err) => {
              // couldn't authorize so send error message @todo
              event.$emit('loading-off')
              console.log(err)
              next('/login')
              event.$emit('logout')
            })
        }
      })
      .catch(() => {
        next('/login')
      })
  } else {
    next()
  }
}

export default AuthCheckRouteGuard



// WEBPACK FOOTER //
// ./src/modules/authentication/middleware/AuthCheckRouteGuard.js